import angular from 'angular';
import checkOverflow from './check-overflow.directive';

export default angular
  .module('verifyApp.check-overflow', [])
  .directive('checkOverflow', checkOverflow)
  .name;



// WEBPACK FOOTER //
// ./client/components/check-overflow/index.js